// src/analytics/firebaseIdentity.js
import { Capacitor } from "@capacitor/core";

let cachedFirebaseId = null;

export async function getFirebaseAppInstanceId() {
  if (!Capacitor.isNativePlatform()) return null;
  if (cachedFirebaseId !== null) return cachedFirebaseId;

  try {
    const { FirebaseAnalytics } = await import(
      "@capacitor-firebase/analytics"
    );
    const { appInstanceId } =
      await FirebaseAnalytics.getAppInstanceId();

    cachedFirebaseId = appInstanceId || null;
    return cachedFirebaseId;
  } catch (e) {
    console.warn("[Firebase] Failed to get appInstanceId", e);
    return null;
  }
}